import { CancellationOptionsQuery } from '@website/types/graphqlOperations';

/**
 * Cancellation options
 *
 * @example
 * <>
 *   <option key="FULL_REFUND">Full refund</option>
 *   //...
 * </>
 */
export function CancellationOptions({
  cancellationOptions,
}: {
  cancellationOptions: CancellationOptionsQuery['booking']['spaces'][0]['cancellationOptions'];
}) {
  // Create html option elements
  const optionHTMLItems = cancellationOptions.map((option) => {
    const adminOnly = !option.guestPermission;

    return (
      <option
        key={option.type}
        value={option.type}
        className={adminOnly ? 'bg-danger text-white' : ''}
      >
        {option.type.replace('_', ' ')}
        {adminOnly && ' (Admin only)'}
      </option>
    );
  });

  return <>{optionHTMLItems}</>;
}
